import { FooterWithChildrenTheme } from "./types";

export const defaultTheme: FooterWithChildrenTheme = {
  container:
    "fixed bottom-0 left-0 right-0 z-10 bg-white p-4 shadow-[0px_4px_10px_4px_rgba(0,0,0,0.16)]",
  layout: "flex flex-col justify-center items-center gap-4",
};
